import { render, staticRenderFns } from "./CreateSystemAccountBtn.vue?vue&type=template&id=2ba640d4&"
import script from "./CreateSystemAccountBtn.vue?vue&type=script&lang=js&"
export * from "./CreateSystemAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports